import * as AddServicesToContractsWizardActions from './actions';
import * as AddServicesToContractsWizardReducer from './reducer';
import * as AddServicesToContractsWizardSelectors from './selectors';

export { provideAddServicesToContractsWizardStore as provideAddServicesToContractsWizardStoreV26 } from './add-services-to-contracts-wizard.providers';
export {
  AddServicesToContractsWizardActions as AddServicesToContractsWizardActionsV26,
  AddServicesToContractsWizardReducer as AddServicesToContractsWizardReducerV26,
  AddServicesToContractsWizardSelectors as AddServicesToContractsWizardSelectorsV26,
};
